import { Column } from '~components/table-view';

export const modalColumns: Column[] = [
  {
    id: 'service_date',
    header: 'Service Date',
    type: 'date',
  },
  {
    id: 'description',
    header: 'Service Name',
    type: 'text',
  },
  {
    id: 'amount',
    header: 'Amount',
    type: 'currency',
    deriveValue: (row) => row.units * row.unit_amount,
    classNames: {
      header: 'cell-align-right',
      column: 'cell-align-right',
    },
  },
];
